import { DeliveryForecastDespatchAdvicePackagingItem } from '../../data/models'
import { DeliveryForecastDespatchAdvicePackagingBatchDetails } from '../../features/delivery-forecast-despatch-advice/data/model'
import i18n from '../../utils/i18n'

export const LabelBodyTemplate = (
  label?:
    | DeliveryForecastDespatchAdvicePackagingItem['PackagingType']
    | DeliveryForecastDespatchAdvicePackagingBatchDetails['PackagingType'],
) => {
  if (!label) return null

  let translation = ''

  switch (label) {
    case 'Master':
      translation = i18n.t(
        'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.options.Master',
      )
      break
    case 'Single':
      translation = i18n.t(
        'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.options.Single',
      )
      break
    case 'Helper':
      translation = i18n.t(
        'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.options.Helper',
      )
      break
    default:
      translation = ''
  }
  return <>{translation}</>
}
